import React, { useEffect, useState } from 'react';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://pagos.academiaholisticaargentina.com/cart/48444837920985:1';
const CHECKOUT_PRO = 'https://pagos.academiaholisticaargentina.com/cart/48444840083673:1';
function getSecondsUntilEndOfDay() {
  const now = new Date();
  const end = new Date(now);
  end.setHours(23, 59, 0, 0);
  const diff = Math.floor((end.getTime() - now.getTime()) / 1000);
  return diff > 0 ? diff : 0;
}
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilEndOfDay);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getSecondsUntilEndOfDay());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="relative bg-black text-white py-12 md:py-16 px-5 sm:px-6 overflow-hidden border-t border-white/5" data-id="element-110">
      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-111">
        <p className="text-white font-serif italic text-2xl md:text-3xl font-bold mb-10" data-id="element-112">
          El próximo paso en tu camino puede empezar hoy.
          <br data-id="element-113" />
          <span className="text-[#eab308]" data-id="element-114">
            "El momento que siempre esperaste ya llegó." 🪷
          </span>
        </p>

        <div className="mb-10" data-id="element-115">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-116">
            ⏰ EL PRECIO CIERRA EN:
          </h2>

          <div className="flex items-center justify-center gap-2" data-id="element-117">
            <span className="bg-[#111111] border border-white/10 text-white px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-118">
              {String(hours).padStart(2, '0')}
            </span>
            <span className="text-white/50 text-xl font-bold" data-id="element-119">hs</span>
            <span className="text-[#eab308] text-2xl font-bold animate-pulse" data-id="element-120">
              :
            </span>
            <span className="bg-[#111111] border border-white/10 text-white px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-121">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-white/50 text-xl font-bold" data-id="element-122">min</span>
            <span className="text-[#eab308] text-2xl font-bold animate-pulse" data-id="element-123">
              :
            </span>
            <span className="bg-[#111111] border border-white/10 text-white px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-124">
              {String(seconds).padStart(2, '0')}
            </span>
            <span className="text-white/50 text-xl font-bold" data-id="element-125">seg</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-10" data-id="element-126">
          {/* Pro CTA */}
          <div className="bg-gradient-to-b from-[#111111] to-[#0a0a0a] rounded-xl p-5 sm:p-6 border-2 border-[#eab308]/50 flex flex-col justify-between relative shadow-[0_0_30px_rgba(234,179,8,0.15)]" data-id="element-127">
            <div className="mb-6" data-id="element-128">
              <h3 className="text-xl font-bold text-white mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-129">
                🏆 MEGAPACK + KIT REIKI PROFESIONAL ⭐
              </h3>
              <p className="text-[#eab308] font-bold text-sm mb-4" data-id="element-130">
                6 Tomos + 6 Bonos + Módulo de Formación de Alumnos
              </p>
              <p className="text-gray-500 text-sm line-through" data-id="element-131">$89.000</p>
              <p className="text-4xl sm:text-5xl font-extrabold text-[#eab308]" style={{
              textShadow: '0 0 30px rgba(234,179,8,0.4)'
            }} data-id="element-132">
                $27.990{' '}
                <span className="text-xl font-bold text-white" data-id="element-133">ARS</span>
              </p>
            </div>
            <a href={CHECKOUT_PRO} target="_blank" rel="noopener noreferrer" className="w-full block px-4 py-4 rounded-xl text-[#0f0f1a] font-bold text-sm tracking-widest uppercase transition-all shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50 text-center" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-134">
              → QUIERO EL MEGAPACK + KIT PROFESIONAL
            </a>
          </div>

          {/* Base CTA */}
          <div className="bg-[#111111] rounded-xl p-5 sm:p-6 border border-white/10 flex flex-col justify-between" data-id="element-135">
            <div className="mb-6 pt-6" data-id="element-136">
              <h3 className="text-xl font-bold text-white mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-137">
                📘 MEGAPACK MAESTRÍA REIKI
              </h3>
              <p className="text-white font-bold text-sm mb-4" data-id="element-138">
                6 Tomos + 6 Bonos · Niveles I, II y Maestría
              </p>
              <p className="text-gray-500 text-sm line-through" data-id="element-139">$69.000</p>
              <p className="text-4xl sm:text-5xl font-extrabold text-white" style={{
              textShadow: '0 0 30px rgba(255,255,255,0.15)'
            }} data-id="element-140">
                $19.990{' '}
                <span className="text-xl font-bold text-gray-400" data-id="element-141">ARS</span>
              </p>
            </div>
            <a href={CHECKOUT_BASE} target="_blank" rel="noopener noreferrer" className="w-full block px-4 py-4 rounded-xl text-white font-bold text-sm tracking-widest uppercase transition-all hover:-translate-y-1 bg-white/10 hover:bg-white/15 border border-white/20 hover:border-white/30 text-center" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-142">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-gray-400 text-xs md:text-sm font-medium" data-id="element-143">
          <span className="flex items-center gap-1.5" data-id="element-144">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-145">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1.5" data-id="element-146">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-1.5" data-id="element-147">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </section>;
}